import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Textarea,
} from '@chakra-ui/react';
import { Field, useField } from 'formik';

const TextAreaInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <FormControl isInvalid={meta.error && meta.touched}>
      {props.formlabel && (
        <FormLabel textStyle="h6" htmlFor={props.formlabel}>
          {props.formlabel}
        </FormLabel>
      )}
      <Field as={Textarea} {...field} {...props} ref={props.innerRef} />
      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};

export default TextAreaInput;
